export default __webpack_public_path__ + "static/media/careersBabcockBtn.4537615c.png";